module.exports = __webpack_public_path__ + "img/section-main-logo.png";